module.exports = __webpack_public_path__ + "62814eea9d68521071ad879684bdc49d.fbx";